import { render, staticRenderFns } from "./MoralStudentsList.vue?vue&type=template&id=ef5e7700&"
import script from "./MoralStudentsList.vue?vue&type=script&lang=js&"
export * from "./MoralStudentsList.vue?vue&type=script&lang=js&"
import style0 from "./MoralStudentsList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports